import keyBy from 'lodash/keyBy';

export default constants => keyBy(constants);
